import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: any;

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    const configUrl = '/assets/config.json'; 
    return firstValueFrom(
      this.http.get(configUrl).pipe(
        catchError((error) => {
          console.warn(
            `Configuração não carregada de ${configUrl}, usando valores padrão.`
          );
          return of(null); 
        })
      )
    )
      .then((data) => {
        if (data) {
          this.config = data;
        } else {
          this.config = environment; 
        }
      })
      .catch((error) => {
        console.error('Erro ao carregar configurações:', error);
        this.config = environment; 
      });
  }

  getConfig(key: string): any {
    return this.config ? this.config[key] : null;
  }
}
